import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { Link } from 'react-router-dom';
import { LogoutIcon, CogIcon } from '@heroicons/react/outline';
import { useAppDispatch } from '@wajeez-web/stores/base';
import { AuthActions, useAuthSelector } from '@wajeez-web/stores/auth';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { ContentEntityTypeActions } from '@wajeez-web/stores/content';

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(' ');
}

const UserMenu = ({ withSettings = true }: { withSettings?: boolean }) => {
  const userNavigation: {
    name: string;
    href: string;
    icon: React.ReactNode;
  }[] = withSettings
    ? [
        // {
        //   name: 'Settings',
        //   href: '/settings',
        //   icon: (
        //     <CogIcon
        //       className="me-3 xl:h-6 xl:w-6 lg:w-5 lg:h-5 md:w-4 md:h-4  text-gray-500 group-hover:text-gray-700"
        //       aria-hidden="true"
        //     />
        //   ),
        // },
      ]
    : [];

  const dispatch = useAppDispatch();
  const { user } = useAuthSelector((state) => state.auth);

  return (
    <Menu as="div" className="relative z-10">
      {({ open }) => (
        <>
          <div>
            <Menu.Button className="  flex items-center text-sm rounded-full focus:outline-none ">
              <span className="sr-only">Open user menu</span>
              <div className="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-7 w-7 text-sidebar-text"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
            </Menu.Button>
          </div>
          <Transition
            show={open || false}
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              static
              className={`origin-top-left absolute ltr:right-0 rtl:left-0 mt-2 xl:w-52 lg:w-48 md:w-36 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none`}
            >
              <div className="px-4 py-3">
                <p className="text-sm text-gray-600">
                  <ReturnTranslatedText
                    origintext="Signed in as"
                    text={`sidebar.menu.${'Signed in as'}`}
                  />
                </p>
                <p className="text-sm font-medium text-gray-900 truncate">
                  {user.email}
                </p>
              </div>

              {userNavigation.length ? (
                <div className="py-2">
                  {userNavigation.map((item) => {
                    if (item) {
                      return (
                        <Menu.Item key={item.name}>
                          {({ active }) => (
                            <Link
                              to={item.href}
                              className={classNames(
                                active ? 'bg-gray-100' : '',
                                'group flex items-center px-4 py-2 text-sm text-gray-700'
                              )}
                            >
                              {item.icon}
                              <ReturnTranslatedText
                                text={`sidebar.menu.${'Settings'}`}
                              />
                            </Link>
                          )}
                        </Menu.Item>
                      );
                    } else {
                      return null;
                    }
                  })}
                </div>
              ) : null}
              <Menu.Item key={'sign out'}>
                {({ active }) => (
                  <div
                    onClick={() => {
                      dispatch(AuthActions.signOutAsync());
                      dispatch(ContentEntityTypeActions.clear());
                    }}
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'group flex items-center cursor-pointer px-4 py-2 text-sm'
                    )}
                  >
                    <LogoutIcon
                      className="me-3 xl:h-6 xl:w-6 lg:w-5 lg:h-5 md:w-4 md:h-4 text-red-500 group-hover:text-red-700"
                      aria-hidden="true"
                    />
                    <ReturnTranslatedText text={`sidebar.menu.${'Log Out'}`} />
                  </div>
                )}
              </Menu.Item>
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
};

export default UserMenu;
